// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_loading-container__czPLU {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 380px;
  padding: 2.5rem 1rem;
  box-sizing: border-box;
}
.Loading_loading-container--fullscreen__BPiUP {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  z-index: 99999;
  background: rgba(248, 250, 252, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.Loading_loading-container--content__6bCIL {
  min-height: calc(100vh - 160px);
  background: transparent;
}
.Loading_loading-container__wrapper__wYThL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  animation: Loading_fadeIn__Ri\\+ah 0.3s ease-out forwards;
}
.Loading_loading-container__spinner-box__bnN5- {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
}
.Loading_loading-container__ring__1MQeh {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3.5px solid rgba(12, 132, 121, 0.15);
  border-top-color: #0c8479;
  border-right-color: #14b8a6;
  animation: Loading_spin__giElo 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
}
.Loading_loading-container__ring-pulse__kZoY- {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #0c8479;
  opacity: 0.25;
  animation: Loading_ping__m-iae 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.Loading_loading-container__logo__THvvP {
  font-weight: 800;
  font-size: 1.15rem;
  letter-spacing: -0.5px;
  color: #0c8479;
  -webkit-user-select: none;
          user-select: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.Loading_loading-container__brand__lNDoC {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 2px;
  color: #0f172a;
}
.Loading_loading-container__brand__lNDoC span {
  display: inline-block;
  animation: Loading_wave__IzFSp 1.4s ease-in-out infinite;
  color: #0c8479;
}
.Loading_loading-container__text__2nDmW {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  letter-spacing: 0.3px;
  animation: Loading_pulseText__zZI1y 1.8s ease-in-out infinite;
}

[m-data-theme="dark"] .Loading_loading-container--fullscreen__BPiUP {
  background: rgba(15, 23, 42, 0.85);
}
[m-data-theme="dark"] .Loading_loading-container--fullscreen__BPiUP .Loading_loading-container__brand__lNDoC {
  color: #f1f5f9;
}
[m-data-theme="dark"] .Loading_loading-container--fullscreen__BPiUP .Loading_loading-container__text__2nDmW {
  color: #94a3b8;
}

@keyframes Loading_spin__giElo {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes Loading_ping__m-iae {
  75%, 100% {
    transform: scale(1.4);
    opacity: 0;
  }
}
@keyframes Loading_wave__IzFSp {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
@keyframes Loading_pulseText__zZI1y {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
@keyframes Loading_fadeIn__Ri\\+ah {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Loading/Loading.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AACF;AACE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,0BAAA;EACA,kCAAA;AACJ;AAEE;EACE,+BAAA;EACA,uBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wDAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,yBAAA;EACA,2BAAA;EACA,iFAAA;AAHJ;AAME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,qEAAA;AAJJ;AAOE;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8EAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AANJ;AAQI;EACE,qBAAA;EACA,wDAAA;EACA,cAAA;AANN;AAUE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,6DAAA;AARJ;;AAaA;EACE,kCAAA;AAVF;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;;AAeA;EACE;IACE,uBAAA;EAZF;EAcA;IACE,yBAAA;EAZF;AACF;AAeA;EACE;IACE,qBAAA;IACA,UAAA;EAbF;AACF;AAgBA;EACE;IACE,wBAAA;IACA,YAAA;EAdF;EAgBA;IACE,2BAAA;IACA,UAAA;EAdF;AACF;AAiBA;EACE;IACE,YAAA;EAfF;EAiBA;IACE,UAAA;EAfF;AACF;AAkBA;EACE;IACE,UAAA;IACA,sBAAA;EAhBF;EAkBA;IACE,UAAA;IACA,mBAAA;EAhBF;AACF","sourcesContent":[".loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 380px;\n  padding: 2.5rem 1rem;\n  box-sizing: border-box;\n\n  &--fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    min-height: 100vh;\n    z-index: 99999;\n    background: rgba(248, 250, 252, 0.88);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n  }\n\n  &--content {\n    min-height: calc(100vh - 160px);\n    background: transparent;\n  }\n\n  &__wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.25rem;\n    animation: fadeIn 0.3s ease-out forwards;\n  }\n\n  &__spinner-box {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n  }\n\n  &__ring {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 3.5px solid rgba(12, 132, 121, 0.15);\n    border-top-color: #0c8479;\n    border-right-color: #14b8a6;\n    animation: spin 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;\n  }\n\n  &__ring-pulse {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 2px solid #0c8479;\n    opacity: 0.25;\n    animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  &__logo {\n    font-weight: 800;\n    font-size: 1.15rem;\n    letter-spacing: -0.5px;\n    color: #0c8479;\n    user-select: none;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  }\n\n  &__brand {\n    display: flex;\n    align-items: center;\n    gap: 0.15rem;\n    font-size: 1.1rem;\n    font-weight: 700;\n    letter-spacing: 2px;\n    color: #0f172a;\n\n    span {\n      display: inline-block;\n      animation: wave 1.4s ease-in-out infinite;\n      color: #0c8479;\n    }\n  }\n\n  &__text {\n    margin: 0;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #64748b;\n    letter-spacing: 0.3px;\n    animation: pulseText 1.8s ease-in-out infinite;\n  }\n}\n\n// Dark theme support\n:global([m-data-theme=\"dark\"]) .loading-container--fullscreen {\n  background: rgba(15, 23, 42, 0.85);\n\n  .loading-container__brand {\n    color: #f1f5f9;\n  }\n\n  .loading-container__text {\n    color: #94a3b8;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes ping {\n  75%, 100% {\n    transform: scale(1.4);\n    opacity: 0;\n  }\n}\n\n@keyframes wave {\n  0%, 100% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translateY(-4px);\n    opacity: 1;\n  }\n}\n\n@keyframes pulseText {\n  0%, 100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-container": `Loading_loading-container__czPLU`,
	"loading-container--fullscreen": `Loading_loading-container--fullscreen__BPiUP`,
	"loading-container--content": `Loading_loading-container--content__6bCIL`,
	"loading-container__wrapper": `Loading_loading-container__wrapper__wYThL`,
	"fadeIn": `Loading_fadeIn__Ri+ah`,
	"loading-container__spinner-box": `Loading_loading-container__spinner-box__bnN5-`,
	"loading-container__ring": `Loading_loading-container__ring__1MQeh`,
	"spin": `Loading_spin__giElo`,
	"loading-container__ring-pulse": `Loading_loading-container__ring-pulse__kZoY-`,
	"ping": `Loading_ping__m-iae`,
	"loading-container__logo": `Loading_loading-container__logo__THvvP`,
	"loading-container__brand": `Loading_loading-container__brand__lNDoC`,
	"wave": `Loading_wave__IzFSp`,
	"loading-container__text": `Loading_loading-container__text__2nDmW`,
	"pulseText": `Loading_pulseText__zZI1y`
};
export default ___CSS_LOADER_EXPORT___;
